import { Box, OnDesktop, OnMobile } from '@hopskipdrive/react-components';

import { actions, Can, subjects } from '../../contexts/AbilityContext';
import { ActionBar, ButtonLink } from '../../shared/components';

export const RidesActionBars = () => (
  <ActionBar>
    <ActionBar.Title title="Rides" />
    <ActionBar.SideControls>
      <Can I={actions.add} a={subjects.ride}>
        <Box display="flex" gap="8px">
          <OnDesktop>
            <ButtonLink variant="contained" color="secondary" size="large" to="/rides/new">
              Create Ride
            </ButtonLink>
            <ButtonLink variant="contained" color="primary" size="large" to="/rideseries/new">
              Create Ride Series
            </ButtonLink>
          </OnDesktop>
          <OnMobile>
            <ButtonLink variant="contained" color="secondary" size="medium" to="/rides/new">
              Create Ride
            </ButtonLink>
            <ButtonLink variant="contained" color="primary" size="medium" to="/rideseries/new">
              Create Ride Series
            </ButtonLink>
          </OnMobile>
        </Box>
      </Can>
    </ActionBar.SideControls>
  </ActionBar>
);
